export default __webpack_public_path__ + "static/media/Portfolios_bg@2x.d456dbaf.png";